import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const bubblePlaceholderDefaultVariants = {}
const bubblePlaceholderCompoundVariants = []

const bubblePlaceholderSlotNames = [
  [
    "root",
    "bubble-placeholder__root"
  ],
  [
    "icon",
    "bubble-placeholder__icon"
  ],
  [
    "title",
    "bubble-placeholder__title"
  ]
]
const bubblePlaceholderSlotFns = /* @__PURE__ */ bubblePlaceholderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, bubblePlaceholderDefaultVariants, getSlotCompoundVariant(bubblePlaceholderCompoundVariants, slotName))])

const bubblePlaceholderFn = memo((props = {}) => {
  return Object.fromEntries(bubblePlaceholderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const bubblePlaceholderVariantKeys = []
const getVariantProps = (variants) => ({ ...bubblePlaceholderDefaultVariants, ...compact(variants) })

export const bubblePlaceholder = /* @__PURE__ */ Object.assign(bubblePlaceholderFn, {
  __recipe__: false,
  __name__: 'bubblePlaceholder',
  raw: (props) => props,
  variantKeys: bubblePlaceholderVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, bubblePlaceholderVariantKeys)
  },
  getVariantProps
})